import { render, staticRenderFns } from "./MsgDialog.vue?vue&type=template&id=1e285548"
import script from "./MsgDialog.vue?vue&type=script&lang=js"
export * from "./MsgDialog.vue?vue&type=script&lang=js"
import style0 from "./MsgDialog.vue?vue&type=style&index=0&id=1e285548&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports